var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxUserMinusOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30673 7.2056C7.47498 7.2056 8.42205 6.25851 8.42205 5.09023C8.42205 3.92194 7.47498 2.97485 6.30673 2.97485C5.13847 2.97485 4.19141 3.92194 4.19141 5.09023C4.19141 6.25851 5.13847 7.2056 6.30673 7.2056Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57677 13.1288H2.5V12.6701C2.50674 12.0251 2.67682 11.3924 2.99437 10.831C3.31192 10.2696 3.76657 9.79791 4.31585 9.45988C4.86514 9.12184 5.49114 8.92856 6.13537 8.89806C6.19281 8.89534 6.25023 8.89392 6.30758 8.8938C6.36493 8.89392 6.42235 8.89534 6.47979 8.89806C7.12402 8.92856 7.75002 9.12184 8.29931 9.45988C8.61517 9.65426 8.89973 9.89285 9.14493 10.1673",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26953 12.2825H13.5002",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxUserMinusOutline);
export default __webpack_public_path__ + "static/media/icon_16px_user-minus_outline.bd4900c0a75810ac11dc3852e7d72137.svg";
export { ForwardRef as ReactComponent };